import * as types from './types';

const defaultUserInfo = {
  id: '',
  name: '',
  email: '',
  progress: 0,
};

const defaultGroup = { show_content_unavailable: false };

export const state = {
  openCategories: [],
  userInfo: { ...defaultUserInfo },
  categoriesList: [],
  relatedPosts: [],
  projectCache: {},
  currentPost: {},
  introduction: {},
  group: defaultGroup,
};

const findDetail = (categoriesDetails, category) =>
  categoriesDetails.filter(detail => Number(detail.id) === category.id)[0];

const findCategory = (categories, categoryId) => {
  if (!categories) {
    return null;
  }

  for (let i = 0; i < categories.length; i += 1) {
    const category = categories[i];

    if (Number(category.id) === Number(categoryId)) {
      return category;
    }

    const foundCategory = findCategory(category.categories, categoryId);

    if (foundCategory) {
      return foundCategory;
    }
  }

  return null;
};

const findPost = (posts, postId) =>
  posts.filter(post => Number(post.id) === Number(postId))[0];

export const mutations = {
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
    state.group = userInfo.group;
  },
  [types.RESET_USER_INFO](state) {
    state.userInfo = defaultUserInfo;
  },
  [types.SET_CATEGORIES_LIST](state, { categories, categoryId }) {
    if (categoryId === null) {
      state.categoriesList = categories.map(category => ({ ...category, categories: [] }));
      return;
    }

    const category = findCategory(state.categoriesList, categoryId);
    if (!category) {
      return;
    }

    category.categories = categories.map(category => ({ ...category, categories: [] }));

    state.categoriesList = state.categoriesList.map(category => category);
  },
  [types.SET_RELATED_POSTS](state, relatedPosts) {
    state.relatedPosts = relatedPosts;
  },
  [types.SET_CURRENT_POST](state, currentPost) {
    state.currentPost = currentPost;
  },
  [types.SET_POSTS_DETAILS](state, posts) {
    if (!posts || !posts.length || !posts[0].category) {
      return;
    }

    const categoryId = posts[0].category.id;
    const category = findCategory(state.categoriesList, categoryId);

    category.published_posts = category.published_posts.map((post) => {
      const postDetail = findPost(posts, post.id);

      return Object.assign({}, post, postDetail);
    });
  },
  [types.SET_CATEGORIES_STATUS](state, categoriesDetails) {
    state.categoriesList = state.categoriesList.map((category) => {
      const detail = findDetail(categoriesDetails, category);

      return Object.assign({}, category, detail);
    });
  },
  [types.SET_INTRODUCTION](state, introduction) {
    state.introduction = introduction;
  },
  [types.TOGGLE_CATEGORY](state, categoryId) {
    const index = state.openCategories.lastIndexOf(categoryId);

    if (index === -1) {
      state.openCategories.push(categoryId);
      return;
    }

    state.openCategories.splice(index, 1);
  },
  [types.HIDE_CATEGORY](state, categoryId) {
    const index = state.openCategories.lastIndexOf(categoryId);
    if (index === -1) return;
    state.openCategories.splice(index, 1);
  },
  [types.CLOSE_CATEGORIES](state) {
    state.openCategories = [];
  },
  [types.SET_COURSE_PROGRESS](state, progress) {
    const userInfo = { ...state.userInfo };
    userInfo.progress = progress;
    state.userInfo = userInfo;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Index/store/mutations.js